import React, { useState, useEffect } from "react";
import { RxReload } from "react-icons/rx";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { toast } from "react-toastify";
import { statusActiveFormatteruser } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { BiRecycle } from "react-icons/bi";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { FaEllipsisVertical } from "react-icons/fa6";
import { LiaUndoAltSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import useTablePage from "../../../components/CommonComponents/useTablePage";
import moment from 'moment';
import { FaCheck, FaTimes } from "react-icons/fa";
import { MdRemoveRedEye } from "react-icons/md";

function ApprovePartner() {
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/partner/pending-index`
  const approveApi = `${BaseUrl}/admin/partner/approve`
  const rejectApi = `${BaseUrl}/admin/partner/reject`
  const { fetchRequest } = useMyContext()
  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [actionType, setActionType] = useState("approve"); // "approve" or "reject"
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState('')
  const [itemToAction, setItemToAction] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [activeId, setActiveId] = useState(null)
  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })
  const [analytics, setAnalytics] = useState({
    totalPending: 0,
    todayPending: 0,
    weekPending: 0,
    monthPending: 0
  })

  const fetchData = async () => {
    setLoading(true)

    await fetchRequest({
      method: 'GET',
      url: listApi,
      params: {
        page,
        limit: formData?.title ? 9999 : limit,
        search: formData?.title,
      },
      data: {},
    })
      .then(response => {
        const result = response;
        let partnersData = result?.data || [];

        // Apply search filter
        if (formData?.title && formData.title.length > 0) {
          partnersData = partnersData.filter(item =>
            (item.user_username && item.user_username.toLowerCase().includes(formData.title.toLowerCase())) ||
            (item.user_email && item.user_email.toLowerCase().includes(formData.title.toLowerCase())) ||
            (item.user_mobile && item.user_mobile.toLowerCase().includes(formData.title.toLowerCase()))
          );
        }

        // Transform data for display
        const updatedList = partnersData.map((item) => {
          return {
            ...item,
            id: item.id,
            username: item.user_username || 'N/A',
            email: item.user_email || 'N/A',
            mobile: item.user_mobile || 'N/A',
            role: 'Partner',
            active: "Pending",
            user_avatar: item.user_user_avatar || '/default-avatar.png',
            upload_on: item.createdAt,
            commission_percentage: item.commission_percentage || 0,
            applied_date: item.createdAt
          };
        });

        // Calculate analytics
        const now = moment();
        const today = now.startOf('day');
        const weekStart = now.clone().startOf('week');
        const monthStart = now.clone().startOf('month');

        const totalPending = updatedList.length;
        const todayPending = updatedList.filter(p => moment(p.applied_date).isSameOrAfter(today)).length;
        const weekPending = updatedList.filter(p => moment(p.applied_date).isSameOrAfter(weekStart)).length;
        const monthPending = updatedList.filter(p => moment(p.applied_date).isSameOrAfter(monthStart)).length;

        setAnalytics({
          totalPending,
          todayPending,
          weekPending,
          monthPending
        });

        // Implement client-side pagination
        const totalItems = updatedList.length;
        const totalPages = Math.ceil(totalItems / limit);
        const startIndex = (page - 1) * limit;
        const paginatedData = updatedList.slice(startIndex, startIndex + limit);

        setApiData(paginatedData);
        setTotal({
          totalItems,
          totalPages,
          currentPage: page,
          count_all: totalItems,
          totalItems: totalItems
        });

        setLoading(false);
      })
      .catch(error => {
        console.error('Fetch error:', error);
        toast.error(error?.response?.data?.message || error?.message)
        setLoading(false);
      })
  };


  const handleConfirmAction = async () => {
    setShowOverlay(true);

    try {
      let response;

      if (itemToAction.length === 1) {
        // Single approve/reject - use GET endpoints with ID in URL
        const partnerId = itemToAction[0];
        const endpoint = actionType === "approve" ? `${approveApi}/${partnerId}` : `${rejectApi}/${partnerId}`;

        response = await fetchRequest({
          method: 'GET',
          url: endpoint,
          data: {}
        });
      } else {
        // Bulk approve/reject - use POST endpoints with data
        const endpoint = actionType === "approve" ? approveApi : rejectApi;

        response = await fetchRequest({
          method: 'POST',
          url: endpoint,
          data: { partner_ids: itemToAction }
        });
      }

      const result = response;
      if (result?.status) {
        toast.success(result?.message);
        setItemToAction([]);
        closeModal();
      } else {
        toast.error(result?.message);
      }

    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setShowOverlay(false);
      setWithoutRefresh(!withOutRefresh);
    }
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToAction([])
  };

  const openModal = (type) => {
    setActionType(type);
    setModelClose(true);
  };

  const singleApprove = (id) => {
    setModelClose(true);
    setItemToAction([id]);
    setActionType("approve");
  };

  const singleReject = (id) => {
    setModelClose(true);
    setItemToAction([id]);
    setActionType("reject");
  };

  const handleActionData = () => {
    handleConfirmAction();
    closeModal();
  };

  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }

  const partnerFormatter = (data, row) => {
    return (
      <div className="d-flex justify-content-between gap-3 align-items-center">
        <img
          key={row?.user_avatar}
          src={`${row.user_avatar}?v=${row.upload_on ? new Date(row.upload_on).getTime() : Date.now()}`}
          alt="Avatar"
          height="48"
          width="48"
          className="userProfileImageSize rounded-circle object-fit-cover"
          onError={(e) => { e.target.src = '/default-avatar.png'; }}
        />
        <div className="rightUserTitle">
          <p className="userNameProfile text-break">{data}</p>
          <span className="userDateText">Applied: {moment(row?.applied_date).format('MMMM Do YYYY')}</span>
          <small className="text-muted d-block">Commission: {row?.commission_percentage || 0}%</small>
        </div>
      </div>
    );
  };

  const statusFormatter = (cell, row) => {
    return (
      <div className="d-flex justify-content-center">
        <span className="badge bg-warning text-dark">
          Pending Approval
        </span>
      </div>
    );
  };

  const columns = [
    {
      dataField: "username",
      text: "Partner Details",
      formatter: partnerFormatter,
      sort: true,
      classes: "userDesignBox",
      headerClasses: "userDesignBox"
    },
    {
      dataField: "mobile",
      text: "Contact",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <span className="text-break d-flex align-items-center justify-content-center w-100">{cell}</span>
      }
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      headerClasses: "userEmailBox"
    },
    {
      dataField: "commission_percentage",
      text: "Commission",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center w-100">
            <span className="badge bg-info text-dark">{cell || 0}%</span>
          </div>
        )
      }
    },
    {
      dataField: "applied_date",
      text: "Applied Date",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div className="text-center">
            <div>{moment(cell).format('DD MMM YYYY')}</div>
            <small className="text-muted">{moment(cell).format('hh:mm A')}</small>
          </div>
        )
      }
    },
    {
      dataField: "active",
      text: "Status",
      sort: true,
      formatter: statusFormatter,
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <div className="editdropdown"
        onClick={() => setActiveId(row.id)}
        onMouseLeave={() => setActiveId(null)}
        id={`moreOption`}>
        <span className="editdropdown-button">
          <FaEllipsisVertical />
        </span>
        <div className={`editdropdown-menu theme-bg-color ${activeId == row?.id ? "d-block" : "d-none"}  ${formData?.view_type}`}>
          <Link id={`View `} to={`${"/edit-partner/"}${row?.id}`} className="theme-text-color theme-bg-color">
            <span className="theme-text-color">
              <MdRemoveRedEye style={{ width: "20px", height: "20px" }} />
              <MessageBox text="View Details" classname='ms-2 theme-text-color'></MessageBox>
            </span>
          </Link>
          <div id={`approveButton`} onClick={() => singleApprove(row?.id)} className="commonActionPadding theme-bg-color">
            <FaCheck style={{ width: "16px", height: "16px", color: "#28a745" }} />
            <MessageBox text="Approve" classname='ms-2 theme-text-color'></MessageBox>
          </div>
          <div id={`rejectButton`} onClick={() => singleReject(row?.id)} className="commonActionPadding theme-bg-color">
            <FaTimes style={{ width: "16px", height: "16px", color: "#dc3545" }} />
            <MessageBox text="Reject" classname='ms-2 theme-text-color'></MessageBox>
          </div>
        </div>
      </div>
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };

  const selectRow = {
    selected: itemToAction,
  };

  const handleRowSelect = (rowId) => {
    if (itemToAction.includes(rowId)) {
      setItemToAction(itemToAction.filter((id) => id !== rowId));
    } else {
      setItemToAction([...itemToAction, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToAction.length === apiData.length) {
      setItemToAction([]);
    } else {
      setItemToAction(apiData.map((row) => row.id));
    }
  };

  const reloadAction = () => {
    setWithoutRefresh(prev => !prev)
    setApiData([])
    setAnalytics({
      totalPending: 0,
      todayPending: 0,
      weekPending: 0,
      monthPending: 0
    })
  }

  const handleBulkApprove = () => {
    if (itemToAction.length === 0) {
      toast.error("Please select at least one partner to approve.");
      return;
    }
    setActionType("approve");
    setModelClose(true);
  };

  const handleBulkReject = () => {
    if (itemToAction.length === 0) {
      toast.error("Please select at least one partner to reject.");
      return;
    }
    setActionType("reject");
    setModelClose(true);
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh]);

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose &&
        <AdminDeleteModal
          headingText={actionType === "approve" ? "Confirm Approval" : "Confirm Rejection"}
          message={actionType === "approve" ? "Are you sure you want to approve these partner(s)?" : "Are you sure you want to reject these partner(s)?"}
          modelClose={modelClose}
          deleteClose={closeModal}
          deleteAction={handleActionData}
          buttonText={"custom"}
          actionText={actionType === "approve" ? "Approve" : "Reject"}
        />
      }
      <section className="pb-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="col-12 col-md-6 col-lg-3 p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number">
              <p className="countHead mb-2">{analytics?.totalPending}</p>
              <p className="countHead mb-1">Total Pending</p>
              <span className="countDes">Partners Awaiting Approval</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number">
              <p className="countHead mb-2">{analytics?.todayPending}</p>
              <p className="countHead mb-1">Today's Applications</p>
              <span className="countDes">New Applications Today</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number ">
              <p className="countHead mb-2">{analytics?.weekPending}</p>
              <p className="countHead mb-1">This Week</p>
              <span className="countDes">Applications This Week</span>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 p-2">
            <div className="text-center theme-bg-color p-3 rounded-3 alluser_card_number ">
              <p className="countHead mb-2">{analytics?.monthPending}</p>
              <p className="countHead mb-1">This Month</p>
              <span className="countDes">Applications This Month</span>
            </div>
          </div>
        </div>
      </section>

      <AdminNavbar
        heading={"Approve Partners"}
        totalDataLength={total?.totalItems}
        // deleteCount={itemToAction?.length}
        // deleteMethod={() => { }}
        navText={""}
        hideAddButton={true}
      />

      <div className='theme-bg-color p-3 rounded-3 mb-5'>
        <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
          <input
            type='search'
            placeholder='Search partners...'
            name="title"
            className='rounded-3 theme-border-color border-solid-width border-solid table-search theme-bg-color-secondary'
            onChange={handleInput}
            id='searchInput'
          />
          <div className='d-flex align-items-center'>
            <button
              className={`bg-transparent reloadButton custom-tool-tip-parent theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color`}
              onClick={reloadAction}
              id='reloadButton'
            >
              <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
              <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
            </button>

            {itemToAction.length > 0 && (
              <>
                <button
                  className="btn btn-success me-2"
                  onClick={handleBulkApprove}
                  id='bulkApproveButton'
                >
                  <FaCheck className="me-1" />
                  Approve Selected ({itemToAction.length})
                </button>
                <button
                  className="btn btn-danger me-2"
                  onClick={handleBulkReject}
                  id='bulkRejectButton'
                >
                  <FaTimes className="me-1" />
                  Reject Selected ({itemToAction.length})
                </button>
              </>
            )}
          </div>
        </div>

        <AdminTable
          data={apiData}
          loading={loading}
          options={options}
          handlePageChange={handlePageChange}
          page={page}
          pagination={total}
          handleSizePerPageChange={handleSizePerPageChange}
          columns={columns}
          limit={limit}
          selectRow={selectRow}
          multiSelect
          onRowSelect={handleRowSelect}
          onSort={handleSort}
          onSelectAll={handleSelectAll}
          viewType={formData?.view_type}
        />
      </div>
    </>
  );
}

export default ApprovePartner;
